export function profileContentRenderedEvent(params) {
    return new CustomEvent("growtypeChatProfileContentRendered", {
        detail: params
    });
}
